import { render } from "./LeedsDest.vue?vue&type=template&id=3e817624&scoped=true"
import script from "./LeedsDest.vue?vue&type=script&lang=js"
export * from "./LeedsDest.vue?vue&type=script&lang=js"

import "./LeedsDest.vue?vue&type=style&index=0&id=3e817624&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e817624"]])

export default __exports__